
export const parseProposalServicesDataToTable = (listData: Array<any>, sort: {Sort: string, Order: 'desc' | 'asc'} = {Sort: 'VisuCode', Order: 'asc'}) => {
  // const sort = {...sortB, Order: (sortB?.Sort === 'LastModificationDate' && sortB?.Order === 'asc' ? 'desc' : (sortB?.Sort === 'LastModificationDate' && sortB?.Order === 'desc' ? 'asc' : sortB?.Order))}
  // const data: Array<{
  //   columns: Array<{
  //     colIndex: number
  //     value: any
  //     type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action' | 'financial'
  //     rowIndex: number
  //     dataKey: string
  //     rowGuid: string
  //     content?: any
  //   }>
  //   rowType: 'data' | 'header'
  //   rowIndex: number
  //   rowGuid: string
  // }> = []
  const theL = [...listData]
  theL.sort((a: any, b: any) => {
    /*if (sort.Order === 'asc' && a[sort.Sort] >  b[sort.Sort]) {
      return -1
    } else if (sort.Order === 'asc' && a[sort.Sort] <  b[sort.Sort]) {
      return 1
    } else if (sort.Order === 'desc' && a[sort.Sort] >  b[sort.Sort]) {
      return 1
    } else if (sort.Order === 'desc' && a[sort.Sort] <  b[sort.Sort]) {
      return -1
    }*/
    return 0
  })
  return theL.map((v, i) => {
    const aRow: {
      columns: Array<{
        colIndex: number
        value: any
        type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action' | 'financial'
        rowIndex: number
        dataKey: string
        rowGuid: string
        content?: any
      }>
      rowType: 'data' | 'header'
      rowIndex: number
      rowGuid: string
    } = {
      columns: [
        {
          colIndex: 0,
          dataKey: 'VisuCode',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'text',
          value: v.VisuCode,
        },
        {
          colIndex: 0,
          dataKey: 'ServiceTitle',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'text',
          value: v.ServiceTitle,
          // content: {
          //   ProjectTitle: {
          //     className: 'fw-bolder fs-4  text-gray-700',
          //     type: 'text',
          //     value: v.ProjectTitle
          //   },
          //   CompanyName: {
          //     className: 'fs-5 text-muted',
          //     type: 'text',
          //     value: v.CompanyName
          //   }
          // }
        },
        {
          colIndex: 0,
          dataKey: 'Status',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'decimal',
          value: v.Quantity
        },
        {
          colIndex: 0,
          dataKey: 'ProgressPercentage',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'financial',
          value: v.UnitPrice
        },
        {
          colIndex: 0,
          dataKey: 'ProgressPercentage',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'financial',
          value: v.SubTotal,
        },
      ],
      rowGuid: v.Guid,
      rowIndex: i+1,
      rowType: 'data',
    }
    //data.push(aRow)
    return aRow
  })
  // data.sort((a, b) => {
  //   if (a.)
  // })
  //return data
}
